import React, { useEffect } from 'react';
import { useDemo } from '../../contexts/DemoContext';
import { Header } from './Header';
import { SceneNavigator } from './SceneNavigator';
import { Footer } from './Footer';
import { ScreenRouter } from './ScreenRouter';
import { AccessSettingsDialog } from './AccessSettingsDialog';
import { SupportDialog } from './SupportDialog';
import { FieldGuideDrawer } from './FieldGuideDrawer';
import { RestartDialog } from './RestartDialog';
import { RecapNote } from '../story/RecapNote';
export function AppShell() {
  const {
    state,
    announcement
  } = useDemo();
  const {
    quietView,
    reducedMotion,
    highContrast,
    largerText
  } = state.accessPreferences;
  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('a11y-quiet', quietView);
    root.classList.toggle('a11y-reduced', reducedMotion);
    root.classList.toggle('a11y-contrast', highContrast);
    root.classList.toggle('a11y-large', largerText);
  }, [quietView, reducedMotion, highContrast, largerText]);
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, [state.currentScreen, state.prequelStep]);
  return <div className="flex min-h-screen w-full flex-col overflow-x-hidden font-body text-[1.0625rem] text-ink md:text-lg" data-id="element-390" data-mp="3oz06b41s1xr1">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-50 focus:rounded-full focus:bg-teal focus:px-4 focus:py-2 focus:text-cream" data-id="element-391" data-mp="3a0oaezm8at0x">
        Skip to story
      </a>
      <Header data-id="element-392" data-mp="317b48vz5luww" />
      <SceneNavigator data-id="element-393" data-mp="35zm6i5hd9ssm" />
      <main id="main" className="flex-1" data-id="element-394" data-mp="36048zjumh38z">
        <RecapNote data-id="element-395" data-mp="361yx1716xbha" />
        <ScreenRouter data-id="element-396" data-mp="2razt49bavb41" />
      </main>
      <Footer data-id="element-397" data-mp="2rc13scoelvl8" />
      <div aria-live="polite" aria-atomic="true" className="sr-only" data-id="element-398" data-mp="2rcaslwxppwpc">
        {announcement}
      </div>
      <AccessSettingsDialog data-id="element-399" data-mp="2wakq4e6wt9e4" />
      <SupportDialog data-id="element-400" data-mp="2w7q5aljzhmk6" />
      <FieldGuideDrawer data-id="element-401" data-mp="2iajnouazxtwj" />
      <RestartDialog data-id="element-402" data-mp="2ibcqxlaqy19x" />
    </div>;
}